import { DashboardDefinition } from '@/app/pages/dashboard/models/dashboard.models';

export const OPERATIONS_DASHBOARD: DashboardDefinition = {
  key: 'operations',
  title: 'Operations Dashboard',
  subtitle:
    'Monitor exceptions, throughput, and service health across customers and lanes.',
  theme: 'operations',
  asmOnly: true,
  defaultWidgetIds: [
    'trackShipment',
    'activeShipments',
    'totalDisplay',
    'truckloadStatus',
    'atRiskShipments',
    'staleTrackingShipments',
    'upcomingDeliveriesList',
    'recentShipmentActivity',
    'spendSummary',
    'carrierDeliveryPerformance',
    'deliveryDaysChart',
    'expeditedSuppliersChart',
    'shipmentDeliveryChart',
    'serviceTypeChart',
    'shipmentStatusChart',
    'shipmentPickupChart',
    'loadHistory',
  ],
};
